import { PROVIDERS, getProviderEnabled, ORDER_TYPES } from '@exodus/fiat-client'
import moonpayProvider, {
  ENABLED_ASSETS,
  getWidgetUrl as getWidgetUrl_,
} from '@exodus/fiat-client/moonpay'

const createProvider = ({ assets, config, enabled, kyc, ...options } = {}) =>
  moonpayProvider({
    ...options,
    apiKey: config.API_KEY,
    assets: {
      ...ENABLED_ASSETS,
      ...assets,
    },
    enabled: (args) => getProviderEnabled({ ...args, enabled, kyc, provider: PROVIDERS.moonpay }),
  })

export const getWidgetUrl = async ({
  assets,
  config,
  paymentMethod,
  signUrl,
  themeId,
  type,
  ...options
} = {}) => {
  const widgetUrl = getWidgetUrl_({
    ...options,
    themeId,
    type,
    apiKey: config.API_KEY,
    assets: {
      ...ENABLED_ASSETS,
      ...assets,
    },
    paymentMethod,
    url: type === ORDER_TYPES.buy ? config.BUY_URL : config.SELL_URL,
  })

  const parametersToSign = {
    provider: PROVIDERS.moonpay,
    url: widgetUrl,
    ...(themeId ? { themeId } : {}),
  }

  return signUrl(parametersToSign)
}

export default createProvider
